<div class="main-layout flex flex-column">
  <app-partner-style *ngIf="partnerBrandService.data.partner && partnerBrandService.data.partner.brand"></app-partner-style>

  <div class="error-content text-center margin-top-xxbig flex-grow">
    <open-svg-icon name="500" class="medium margin-top-medium margin-bottom-large"></open-svg-icon>

    <h1 class="margin-bottom-medium">Hold up! You're a long way from home</h1>

    <p class="text-small">Error type: 404</p>
    <p class="text-small">&nbsp;</p>
  </div>
  <app-footer class="open-footer" [partnerBrandData]="partnerBrandService.data.partner"></app-footer>
</div>
